module.exports = __webpack_public_path__ + "img/google-stadia-05.e82b0508.jpg";